import React from 'react'

export const Hamburger = () => (
  <svg viewBox="0 0 50 50" width={25} role="presentation" data-testid="hamburger-icon">
    <defs>
      <rect id="line" width={44} height={4} rx={2} fill="#555" />
    </defs>

    <use href="#line" x={3} y={11} />
    <use href="#line" x={3} y={23} />
    <use href="#line" x={3} y={35} />
  </svg>
)
